import React, {useContext} from 'react';
import styled from 'styled-components';
import { changeQuantity, clearCart, getCart, removeFromCart } from '@/store/ls/cart';
import { CartContext } from '@/store/context/cart';
import Button from '../ui/Button';
import Counter from '../ui/Counter';
import { Proizv } from './forPages/search/SearchString';
import { beautyPrice, getMaxQuantity, getMinQuantity, getQuantityStep } from '@/helpers/ost';
import { useRouter } from 'next/router';
import {getCartSum} from "@/services/cart.service";
import {CartTableString} from "./forPages/cart/styles";
import Image from 'next/image';

const CartIcon = '/img/icons/cart.png';

interface IModalCartProps {
  onClose: () => void;
}

export default function ModalCart({
  onClose
}: IModalCartProps) {

  const { cart, setCart } = useContext(CartContext);
  const router = useRouter();

  const removeFromCartHandler = (prepId: number) => {
    removeFromCart(prepId)
    setCart(getCart());
  }

  const onCounterChange = (prepId: number, newValue: number) => {
    changeQuantity(prepId, newValue);
    setCart(getCart());
  }

  const cartSum = getCartSum(cart);

  const goToCartHandler = () => {
    onClose();
    router.push('/cart');
  }

  const clearCartHandler = () => {
    clearCart();
    setCart(getCart());
  }

  return <Container>
    <CloseCart onClick={onClose}>Закрыть</CloseCart>
    <Title>
      Корзина
    </Title>
    <Table>
      {cart && (cart.length > 0) && <>
        <CartTableString className="first-table-string" key="заголовки">
          <div>Наименование</div>
          <div>Количество</div>
          <div><Image src={CartIcon} alt="" width={31} height={28}/></div>
        </CartTableString>
        {cart.map(cartItem => {
          return <CartTableString key={cartItem.prep_id}>
          <TableStringTitle>
            {cartItem.rcfi_name}
            <Proizv>{cartItem.proizv_name}</Proizv>
          </TableStringTitle>
          <Counter
            maxValue={getMaxQuantity(null, cartItem.prep_id)}
            step={getQuantityStep(cartItem.prep_id)}
            value={cartItem.quantity}
            onChange={(newValue) => onCounterChange(cartItem.prep_id, newValue)}
            minValue={getMinQuantity(cartItem.prep_id)}
          />
          <div><RemoveFromCart onClick={() => removeFromCartHandler(cartItem.prep_id)}></RemoveFromCart></div>
        </CartTableString>
        })}
        <ModalCartSum><span>Сумма корзины</span>: от {beautyPrice(cartSum)} руб.</ModalCartSum>
      </>
      }

      {cart && (cart.length === 0) && <div>
        Ваша корзина пуста</div>}

    </Table>
    {cart && (cart.length > 0) && <><Button onClick={goToCartHandler}>
      Показать аптеки
    </Button>
    <ClearCart onClick={clearCartHandler}>
      Очистить корзину
    </ClearCart></>}
  </Container>
}

const ClearCart = styled.a`
  color: var(--red);
  position: absolute;
  right: 40px;
  bottom: 40px;

  @media (max-width: 480px) {
    position: static;
    display: block;
    margin-top: 20px;
  }
`

const ModalCartSum = styled.div`
  margin-top: 20px;
  font-family: var(--font-semibold);
  & span {
    text-transform: uppercase;
  }
`

const CloseCart = styled.a`
  position: absolute;
  right: 0;
  top: -40px;
  color: var(--color-text-invert);
  padding: 10px;

  @media (max-width: 480px) {
    color: var(--green);
    top: -6px;
  }
`

const Container = styled.div`
  position: relative;
  padding: 30px 20px;
  text-align: center;
  background-color: var(--color-bg);
  width: 800px;
  max-width: calc(100% - 80px);
  border-radius: 20px;
  color: var(--color-title);
  line-height: var(--line-height-normal);

  @media (max-width: 480px) {
    width: 100%;
    max-width: 100%;
    padding: 30px 20px;
    max-height: 100%;
    overflow-y: scroll;
  }
`
const Title = styled.h2`
  font-size: var(--text-title);
  text-transform: uppercase;
  font-family: var(--font-semibold);
  color: var(--color-title);
  margin: 0 0 40px;

  & span {
    color: var(--green);
  }

  @media (max-width: 480px) {
    font-size: 22px;
    margin-bottom: 20px;
  }
`

// const Inputs = styled.div`
//   display: grid;
//   grid-template-columns: auto 1fr;
//   grid-column-gap: 20px;
//   margin-bottom: 20px;
//   text-align: left;
//   grid-row-gap: 15px;
//   align-items: center;

//   & input {
//     border-radius: 4px;
//     border: 1px solid var(--green);
//     height: 35px;
//     padding: 0px 10px;
//   }
// `

// const CheckboxContainer = styled.div`
//   margin-bottom: 20px;
//   font-size: var(--text-normal);

//   & input {
//     position: absolute;
//     z-index: -1;
//     left: 0px;
//     top: 0px;
//   }

//   & div {
//     position: relative;
//     padding-left: 30px;
//     display: inline-block;
//   }
//   & div::before {
//     content: '';
//     position: absolute;
//     left: 0px;
//     top: 0px;
//     width: 20px;
//     height: 20px;
//     box-sizing: border-box;
//     border: 1px solid var(--green);
//     border-radius: 4px;
//   }

//   & input:checked + div::after{
//     content: '';
//     font-family: var(--font-awesome);
//     position: absolute;
//     left: 3px;
//     top: 0px;
//   }

//   & a {
//     color: var(--green);
//   }
// `

const Table = styled.div`
  margin-bottom: 20px;
`

export const RemoveFromCart = styled.a`
  display: inline-block;
  font-family: var(--font-awesome);
  padding: 5px 7px;
  border: 1px solid var(--red);
  color: var(--red);
  border-radius: 50%;
  margin-left: 4px;
  line-height: initial;

  &:hover {
    color: var(--red) !important;
  }

  @media (max-width: 480px) {
    border-radius: 5px;
    padding: 4px 7px;
    font-size: 0;
    &::after {
      content: 'Удалить';
      font-family: var(--font-regular);
      font-size: var(--text-normal);
    }
  }
`

export const TableStringTitle = styled.div`
  /* white-space: nowrap;
  overflow-x: scroll; */
  line-height: normal;
  text-align: left;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  @media (max-width: 480px) {
    grid-column: 1/3;
  }
`